import styled from 'styled-components';
import type { Variant } from 'components/Toolkit/Inputs/types';

const Label = styled.label<{ variant?: Variant; capitalize?: boolean }>`
  display: block;
  ${({ theme, variant = 'DEFAULT' }) => {
    switch (variant) {
      case 'DEFAULT':
        return `
          ${theme.fontSize.M14}
          color: ${theme.colors.GREY};
          margin-bottom: ${theme.spacing.S2};
        `;
      case 'COMFORT':
        return `
          ${theme.fontSize.M16}
          color: ${theme.colors.GREY_DARK};
          margin-bottom: ${theme.spacing.S8};
        `;
    }
  }}
  ${({ capitalize }) => capitalize && 'text-transform: capitalize;'}
`;

export { Label };
